export const CHANGE_UI_STATUS = "CHANGE_UI_STATUS";

export const changeUIStatus = (state) => {
  return { type: CHANGE_UI_STATUS, payload: state };
};


